// extracted by mini-css-extract-plugin
module.exports = {"container":"DangerButton_container__3DayU","button":"DangerButton_button__1d47R"};